export const baseQueryParamMapping = Object.freeze({
  contentTags: { queryParamName: 'contentTags', type: 'array', elementType: 'string' },
  contentTagMatchType: { queryParamName: 'contentTagMatchType', type: 'string' },
  'reportingPeriod.range.start': { queryParamName: 'startDate', type: 'date' },
  'reportingPeriod.range.end': { queryParamName: 'endDate', type: 'date' },
  'sort.selected.value': { queryParamName: 'sort', type: 'string' },
  'sort.sortOrder': { queryParamName: 'sortOrder', type: 'string' },
});

export const defaultReportingPeriod = Object.freeze({
  preset: 'ALL_TIME',
  presetObject: {
    label: 'All Time',
    value: 'ALL_TIME',
  },
  range: undefined,
});
